// extracted by mini-css-extract-plugin
export default {"mpd-list-loader-animated":"styles_mpd-list-loader-animated__mU5us","placeHolderShimmer":"styles_placeHolderShimmer__FSmbS","auto-response":"styles_auto-response__Q5AOT"};